module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/fail@2x_1e03f3.png";